import { IMenuItem } from 'models/IMenuItem';
import { take } from 'utils';
import Categories from './themes/BGH/Categories';

export interface Category extends IMenuItem {
  showAllCategories: boolean;
}

export const mapToCategories = (numberOfItems: number, menuItems: IMenuItem[]): Category[] =>
  menuItems.map(menuItem => ({
    ...menuItem,
    subCategories: take(menuItem.subCategories, numberOfItems),
    showAllCategories:
      menuItem.subCategoriesCount !== undefined && menuItem.subCategoriesCount > numberOfItems
  }));

interface OwnProps {
  categories: Category[];
  showAllCategoriesText: string;
}

export default ({ categories, showAllCategoriesText }: OwnProps) => (
  <Categories categories={categories} showAllCategoriesText={showAllCategoriesText} />
);
